'use strict';

var videojsPlugin = require('video.js').default;
var videojsYoutubePlugin = require('videojs-youtube'); // eslint-disable-line

var videoDefaultOptions = require('../configs/videoDefault.json');

/**
 * Getting video source object
 * @param {string} url - video URL
 * @returns {Object} configuration object
 */
function getVideoSource(url) {
    var config = {};
    var type = '';
    if (url) {
        if (url.indexOf('www.youtube.com') !== -1) {
            type = 'video/youtube';
        } else {
            type = 'video/mp4';
        }

        config.sources = [
            {
                src: url,
                type: type
            }
        ];
    }
    return config;
}

/**
 * Getting poster url string
 * @param {string} videoId - id of video
 * @returns {string} - url string
 */
function getPosterUrl(videoId) {
    return 'https://img.youtube.com/vi/' + videoId + '/maxresdefault.jpg';
}

/**
 * @function
 * @description initEvents
 */
function initEvents() {
    var $this = this;
    $(document).on('click', '.js-video-create-btn', function () {
        var $this = $(this);
        var $videoBlock = $('.js-video-block');
        var videoUrl = $this.data('url');
        var videoId = $this.data('video-id');
        var posterUrl = getPosterUrl(videoId);
        var videoPlayer = $('.js-video')[0].player;
        videoPlayer.src(getVideoSource(videoUrl).sources);
        $('.vjs-poster').css('background-image', 'url(' + posterUrl + ')');
        $videoBlock.removeClass('is-played');
        $videoBlock.addClass('is-loaded-list-video');
    });

    $(document).on('click', '.js-videoplay-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $playBtn = $(this);
        var $videoBlock = $playBtn.closest('.js-video-block');

        const $carouselElement = $videoBlock.closest('.slick-slider');

        var $videoElSelector = $videoBlock.find('.js-video');
        var videoElement = $videoElSelector[0];

        // Check if the video block is inside Slick carousel
        if ($carouselElement.length > 0) {
            // Check if the clicked video block is the currently active Slick slide
            const isCurrentSlide = $videoBlock.is('.slick-current');

            if (isCurrentSlide) {
                if (!videoElement || !videoElement.player) {
                    this.create($videoElSelector[0]);
                    videoElement = $videoElSelector[0];
                }

                if (videoElement && videoElement.player) {
                    const videoPlayer = videoElement.player;
                    if (videoPlayer.paused()) {
                        const playPromise = videoPlayer.play();
                        if (playPromise !== undefined) {
                            playPromise.then(() => {
                                $videoBlock.removeClass('is-loaded-list-video');
                                $videoBlock.addClass('is-played');
                            }).catch(error => {
                                console.error('Play() failed:', error);
                                $(videoElement).removeClass('vjs-controls-disabled');
                            });
                        } else {
                            $videoBlock.removeClass('is-loaded-list-video');
                            $videoBlock.addClass('is-played');
                        }

                        window.setTimeout(function () {
                            $(videoElement).removeClass('vjs-controls-disabled');
                        }, 500);
                    } else {
                        videoPlayer.pause();
                        $videoBlock.removeClass('is-played');
                    }
                } else {
                    console.error('Video element or player instance not found after clicking play button on current slide in carousel.');
                }
            } else {
                if ($carouselElement.hasClass('slick-initialized')) {
                    $carouselElement.slick('slickNext');
                }
            }
        } else {
            // Avoid calling create if player is already initialized
            if (!videoElement || !videoElement.player) {
                this.create($videoElSelector[0]);
                videoElement = $videoElSelector[0];
            }

            if (videoElement && videoElement.player) {
                const videoPlayer = videoElement.player;
                if (videoPlayer.paused()) {
                    const playPromise = videoPlayer.play();
                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                            $videoBlock.removeClass('is-loaded-list-video');
                            $videoBlock.addClass('is-played');
                        }).catch(error => {
                            console.error('Standalone play() failed:', error);
                            $(videoElement).removeClass('vjs-controls-disabled');
                        });
                    } else {
                        $videoBlock.removeClass('is-loaded-list-video');
                        $videoBlock.addClass('is-played');
                    }

                    window.setTimeout(function () {
                        $(videoElement).removeClass('vjs-controls-disabled');
                    }, 500);
                } else {
                    videoPlayer.pause();
                    $videoBlock.removeClass('is-played');
                }
            } else {
                console.error('Video element or player instance not found after clicking play button on standalone video.');
            }
        }
    });

    $(document).on('initVideos', function (event, data) {
        $this.init({
            container: data.container
        });
    });
}

/**
 * Event handler for video
 * @param {Object} videoPlayer - Video player
 */
function initEventHandler(videoPlayer) {
    videoPlayer.on('play', function () {
        if ($('.js-video-block').is('.is-loaded-list-video')) {
            videoPlayer.pause();
        }
    });

    videoPlayer.on('ended', function () {
        videoPlayer.hasStarted(false);
    });
}

module.exports = {
    init: function () {
        var $this = this;
        var $videoBlocks = $('.js-video:not(.m-lazy-loaded)');

        if ($videoBlocks.length > 0) {
            $videoBlocks.each(function () {
                $this.create(this);
            });
        }
    },

    initEvents: initEvents,

    create: function (selector) {
        if (!selector) {
            return;
        }

        var $video = $(selector);
        var videoSources = getVideoSource($video.data('video'));
        var videoOptions = $.extend({}, videoDefaultOptions, videoSources);

        videojsPlugin($video.get(0), videoOptions, function () {
            var videoPlayer = this;
            var videoElement = videoPlayer.contentEl();
            var $videoElement = $(videoElement);

            $videoElement.addClass('js-video-el m-inited');

            $videoElement.closest('.slick-slider').on('beforeChange', function () {
                var videoElement = $videoElement[0];
                if (videoElement && videoElement.player) {
                    videoPlayer.pause();
                }
            });

            videoElement.player = videoPlayer;

            initEventHandler(videoPlayer);
        });
    }
};
